module.exports = __webpack_public_path__ + "static/media/jcb.e095343b.svg";